import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  expose: {
    list: [],
    types: {},
    listLoading: false,
  },
};

export const mutations = {
  EXPOSE_SET_LIST(state, list) {
    state.expose.list = list;
  },
  EXPOSE_SET_LIST_LOADING(state, isLoading) {
    state.expose.listLoading = isLoading;
  },
  EXPOSE_SET_TYPES(state, types) {
    state.expose.types = types;
  },
};

export const getters = {
  getExposeList: state => state.expose.list,
  getExposeTypes: state => state.expose.types,
};

export const actions = {
  fetchFpExposeList({ commit }, payload) {
    commit('EXPOSE_SET_LIST_LOADING', true);

    const params = {};
    if (payload && payload.status && payload.status !== 'open') {
      params.status = payload.status;
    }

    return axios.get(`${window.BASE_API.EXPOSE_BASE}/expose/list`, { params })
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          commit('EXPOSE_SET_LIST_LOADING', false);
          commit('EXPOSE_SET_LIST', response);
        });
      })
      .catch((err) => {
        commit('EXPOSE_SET_LIST_LOADING', false);
        commit('EXPOSE_SET_LIST', []);

        return Promise.reject(err.response && err.response.data ? err.response.data : err);
      });
  },
  fetchFpExposeAll({ dispatch }) {
    return dispatch('fetchFpExposeList').catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err));
  },
  fetchFpExposeTypes({ commit }) {
    return axios.get(`${window.BASE_API.EXPOSE_BASE}/expose/templates`)
      .then(({ data }) => {
        commit('EXPOSE_SET_TYPES', data);

        return data.data;
      })
      .catch((err) => {
        commit('EXPOSE_SET_TYPES', {});

        return Promise.reject(err.response && err.response.data ? err.response.data : err);
      });
  },
  createExpose({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.EXPOSE_BASE}/expose/create`, payload)
      .then((data) => {
        dispatch('fetchFpExposeAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  deleteExpose({ dispatch }, id) {
    return axios.delete(`${window.BASE_API.EXPOSE_BASE}/expose/delete/${id}`)
      .then((data) => {
        dispatch('fetchFpExposeAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const expose = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default expose;



// WEBPACK FOOTER //
// ./src/store/financialProducts/financialProductExpose.js